const outlined: object = {
  transparent: {
    backgroud: "bg-transparent",
    color: "text-blue-gray-900",
  },
  white: {
    border: "border border-white",
    color: "text-white",
  },
  "blue-gray": {
    border: "border border-blue-gray-500",
    color: "text-blue-gray-500",
  },
  gray: {
    border: "border border-gray-500",
    color: "text-gray-500",
  },
  brown: {
    border: "border border-brown-500",
    color: "text-brown-500",
  },
  "deep-orange": {
    border: "border border-deep-orange-500",
    color: "text-deep-orange-500",
  },
  orange: {
    border: "border border-orange-500",
    color: "text-orange-500",
  },
  amber: {
    border: "border border-amber-500",
    color: "text-amber-500",
  },
  yellow: {
    border: "border border-yellow-500",
    color: "text-yellow-500",
  },
  lime: {
    border: "border border-lime-500",
    color: "text-lime-500",
  },
  "light-green": {
    border: "border border-light-green-500",
    color: "text-light-green-500",
  },
  green: {
    border: "border border-green-500",
    color: "text-green-500",
  },
  teal: {
    border: "border border-teal-500",
    color: "text-teal-500",
  },
  cyan: {
    border: "border border-cyan-500",
    color: "text-cyan-500",
  },
  "light-blue": {
    border: "border border-light-blue-500",
    color: "text-light-blue-500",
  },
  blue: {
    border: "border border-blue-500",
    color: "text-blue-500",
  },
  indigo: {
    border: "border border-indigo-500",
    color: "text-indigo-500",
  },
  "deep-purple": {
    border: "border border-deep-purple-500",
    color: "text-deep-purple-500",
  },
  purple: {
    border: "border border-purple-500",
    color: "text-purple-500",
  },
  pink: {
    border: "border border-pink-500",
    color: "text-pink-500",
  },
  red: {
    border: "border border-red-500",
    color: "text-red-500",
  },
};

export default outlined;
